import PropTypes from 'prop-types';
import { hasPermission, hasAnyPermission, hasAllPermissions } from '../../utils/permissions';
import { getStoredUser } from '../../utils/accessControl';

/**
 * A wrapper component that conditionally renders its children based on permissions.
 */
export default function Authorized({ 
  permission, 
  anyPermission, 
  allPermissions, 
  fallback = null, 
  children 
}) {
  const user = getStoredUser();
  let isAuthorized = true;

  if (permission) {
    isAuthorized = hasPermission(permission, user);
  } else if (anyPermission) {
    isAuthorized = hasAnyPermission(anyPermission, user);
  } else if (allPermissions) {
    isAuthorized = hasAllPermissions(allPermissions, user);
  }

  return isAuthorized ? children : fallback;
}

Authorized.propTypes = {
  permission: PropTypes.string,
  anyPermission: PropTypes.arrayOf(PropTypes.string),
  allPermissions: PropTypes.arrayOf(PropTypes.string),
  fallback: PropTypes.node,
  children: PropTypes.node.isRequired
};
